<template>
  <div class="mood-selector">
    <button 
      class="mood-btn sunny-btn" 
      :class="{ active: isSunnyMode }" 
      @click="setSunnyMode" 
      title="Sunny Mode"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="5"></circle>
        <line x1="12" y1="1" x2="12" y2="3"></line>
        <line x1="12" y1="21" x2="12" y2="23"></line>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
        <line x1="1" y1="12" x2="3" y2="12"></line>
        <line x1="21" y1="12" x2="23" y2="12"></line>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
      </svg>
      <span class="tooltip">Sunny Mode</span>
    </button>
    
    <button 
      class="mood-btn rainy-btn" 
      :class="{ active: !isSunnyMode }" 
      @click="setRainyMode" 
      title="Rainy Mode"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 16.2A4.5 4.5 0 0 0 17.5 8h-1.8A7 7 0 1 0 4 14.9"></path>
        <path d="M16 14v6"></path>
        <path d="M8 14v6"></path>
        <path d="M12 16v6"></path>
      </svg>
      <span class="tooltip">Rainy Mode</span>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useThemeStore } from '../stores/theme'

export default {
  name: 'MoodSelector',
  computed: {
    ...mapState(useThemeStore, ['isSunnyMode'])
  },
  methods: {
    ...mapActions(useThemeStore, ['setSunnyMode', 'setRainyMode'])
  },
  mounted() {
    // Initialize theme from localStorage or system preference
    const themeStore = useThemeStore()
    themeStore.initTheme()
  }
}
</script>

<style lang="scss" scoped>
.mood-selector {
  display: flex;
  gap: 0.5rem;
}

.mood-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
  color: var(--color-text);
  
  &:hover {
    transform: scale(1.1);
    
    .tooltip {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
  
  &.active {
    color: var(--color-primary);
    background-color: rgba(var(--color-primary-rgb, 248, 198, 48), 0.1);
  }
  
  .tooltip {
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%) translateY(5px);
    background-color: var(--color-card-bg);
    color: var(--color-text);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px var(--color-shadow);
    pointer-events: none;
  }
}

.sunny-btn {
  &.active {
    color: #f8c630;
  }
}

.rainy-btn {
  &.active {
    color: #3498db;
  }
}
</style> 